module.exports = __webpack_public_path__ + "static/media/loginImage.5389641b.png";